import React, {useState, useEffect} from 'react'
import { useParams,useNavigate,NavLink } from 'react-router-dom';
import { Button } from "@wfp/ui";
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';
import { Navbar } from '../../components/ui/NavBar';
import {encode as base64_encode} from 'base-64';
import  { GetCourseInfo }  from '../../controllers/GetCourseInfo';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import  { positionByCourse }  from '../../controllers/positionByCourse';
import  { PositionInsert }  from '../../controllers/PositionInsert';

// Home to display "Curso"
export const CoursesScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const [cursoNombre, setCursoNombre] = useState('');
    const [course, setCourse] = useState([]);
    const { cursoId } = useParams();
    localStorage.setItem('courseId',cursoId);
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    let ran = false;
    useEffect(() => {
        if (ran) return;
            // console.log({cursoId})
            GetCourseInfo(cursoId, user.languaje, token, user.id)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                setCourse(e[0]);
                setCursoNombre(e[0].name)
                // console.log(e)
                localStorage.setItem('courseColor',e[0].tertiary_color);
                localStorage.setItem('courseColorOne',e[0].primary_color);
                localStorage.setItem('courseColorTwo',e[0].secondary_color);
                localStorage.setItem('courseColorThree',e[0].quadrennial_color);
                localStorage.setItem('courseName',e[0].name);
                localStorage.setItem('courseId',cursoId);
            })
            .catch((e)=>{
                console.error(e);
            });

            positionByCourse( token, user.id, cursoId)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                // console.log({cursoId}, e)
                if(e.length>0){
                    history( e[e.length - 1].url, {
                        replace: true
                    }); 
                }else{
                    PositionInsert( token, user.id, cursoId, `/units/${ cursoId }`)
                    .catch((e)=>{
                        console.error(e);
                        dispatch(logout(token));
                    });
                }
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
        return () => (ran = true);
      }, [cursoId]);
    if(cursoId===''){
        history( '/home', {
            replace: true
          });
    }
    const parseHTML = (htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        const body = doc.body;
    
        return Array.from(body.childNodes).map((node, index) => {
        const key = `node_${index}`;
    
        if (node.nodeType === Node.ELEMENT_NODE) {
            // Crea componentes para las etiquetas HTML necesarias
            const tagName = node.tagName.toLowerCase();
    
            if (tagName === 'b' || tagName === 'strong') {
            return <strong key={key}>{parseHTML(node.innerHTML)}</strong>;
            } else if (tagName === 'p') {
            return <p key={key}>{parseHTML(node.innerHTML)}</p>;
            }
        } else if (node.nodeType === Node.TEXT_NODE) {
            // Renderiza el texto
            return node.nodeValue;
        }
    
        return null;
        });
    };

    const disCourse = ()=>{
        return (course)?
            <div key={course.id} >
                <div className="img-course-back">
                {
                    (course.icon_text_type==="svg")
                    ?
                    <img className="img-course-m" src = {`data:image/svg+xml;base64,${base64_encode(course.icon_text)}`} alt={course.name}/>
                    :
                    (course.icon_text_type!==null)?
                    <img className="img-course-m" src = {`data:image/${course.icon_text_type}+xml;base64,${btoa(course.icon_text)}`} alt={course.name}/>
                    :null
                }
                </div>
                <div className="course-description" style={{whiteSpace: 'pre-line'}}>{parseHTML(course.text_value)}
                    <div className="course-enter">
                        <NavLink to={ `/units/${ course.id }` } className="wfp--link">
                            <Button
                                    id="btnIngresar"
                                    type="submit"
                                    className="btn m-1 btn-block btn-wfp-main btn-question-p"
                                    style={{
                                        backgroundColor: course.tertiary_color,
                                        borderColor:  course.tertiary_color,
                                    }}
                                >
                                    {transTxt.btn.continuar.txt}
                            </Button>
                        </NavLink>
                    </div>
                    <br />
                    <br />
                    <br />
                </div>
            </div>
            :null;
        
    }
    
    return (
            <div className="fund-main-course">

                <Navbar title={cursoNombre} />
                {
                    course && (course.background_home_type==="svg")
                    ?
                    <img className="fund-start-b-imgc" src = {`data:image/svg+xml;base64,${base64_encode(course.background_home)}`} alt="Back Ground"/>
                    :(course.background_home_type!==null)?
                    <img className="fund-start-b-imgu" src = {`data:image/${course.background_home_type}+xml;base64,${btoa(course.background_home)}`} alt="Back Ground"/>
                    :null
                }
                <div className="content-course" >
                {!course && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>} 
                {course && disCourse() }
                </div>
            </div>

    )
}

